import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children, allowedRoles }) => {
  const { isLoggedIn, user } = useSelector((state) => state.authSlice);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/auth/login", {
        replace: true,
        state: { from: location },
      });
    } else if (allowedRoles && !allowedRoles.includes(user?.role)) {
      navigate("/", { replace: true });
    }
  }, [isLoggedIn, user, allowedRoles, navigate, location]);

  if (!isLoggedIn) return null;

  if (allowedRoles && !allowedRoles.includes(user?.role)) return null;

  return children;
};

export default PrivateRoute;
